import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardContent, Typography, Box } from "@mui/material";

const ModeSelection = () => {
    const { topicId } = useParams();
    const navigate = useNavigate();

    const handleModeSelection = (mode) => {
        if (mode === "basic") {
            navigate(`/quiz/${topicId}`);
        } else if (mode === "gamified") {
            navigate(`/quiz/gamified/${topicId}`);
        } else if (mode === "interactive") {
            navigate(`/quiz/interactive/${topicId}`);
        }
    };

    return (
        <Box sx={{ maxWidth: 500, mx: "auto", mt: 5 }}>
            <Card sx={{ boxShadow: 3, p: 2 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight="bold">
                        Select a Mode
                    </Typography>
                    <Button variant="contained" sx={{ mt: 2 }} onClick={() => handleModeSelection("basic")}>
                        Basic Mode
                    </Button>
                    <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => handleModeSelection("gamified")}>
                        Gamified Mode
                    </Button>
                    <Button variant="contained" color="error" sx={{ mt: 2 }} onClick={() => handleModeSelection("interactive")}>
                        Interactive Mode
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ModeSelection;
